  <!-- ***************SG-4637 start  ******************* -->

<div fxLayout="row" [ngClass]="['card-height']" fxLayoutAlign="space-between" fxLayoutGap="10px">
    <mat-card class="flx-card wd-mx crd-ovrflw bottom-card-ht av-loader-host">
        <div class="av-loader-overlay" *ngIf="avLoader.loading$ | async">
            <mat-spinner diameter="36"></mat-spinner>
        </div>
        <mat-card-header class="grp_hdr">
            <article [ngClass]="['header-padding']">
                <div fxLayout="column" fxLayoutAlign="start center">
                    <h4 ngClass="selectlist-label" *ngIf="dateType?.type == 'month' || dateType?.type == 'Month'">Last 24
                        Month's Data</h4>
                    <h4 ngClass="selectlist-label" *ngIf="dateType?.type == 'day' || dateType?.type == 'Day'">Last 1
                        Month's Data</h4>
                    <h4 ngClass="selectlist-label" *ngIf="dateType?.type === 'year' || dateType?.type === 'Year'">Last 5
                        Year's Data</h4>
                </div>
                <nav class="nv_rt rpd">
                    <div fxLayout="row" fxLayoutGap="10px">
                        <div fxLayout="column" fxLayoutAlign="end center" class="chart-header-dropdown">
                            <div fxLayout="row">
                                <h4 ngClass="selectlist-label"
                                    *ngIf="usageAnalyticsSelectedValue !== 'totalPlayedSession' &&
                            usageAnalyticsSelectedValue !== 'averageDuration' &&
                            usageAnalyticsSelectedValue!=='masteredPracticeSets' && usageAnalyticsSelectedValue === 'All'">
                                    Usage : </h4>
                                <h4 ngClass="selectlist-label" *ngIf="usageAnalyticsSelectedValue === 'TotalMissions'">
                                    Total Missions Sessions :
                                </h4>
                                <h4 ngClass="selectlist-label"
                                    *ngIf="usageAnalyticsSelectedValue === 'AvgMissionDuration'">Average Mission
                                    Duration :
                                </h4>
                                <h4 ngClass="selectlist-label"
                                    *ngIf="usageAnalyticsSelectedValue === 'ClearedMissions'">Total Cleared Missions :
                                </h4>

                                <h4 ngClass="selectlist-label"
                                    *ngIf="usageAnalyticsSelectedValue === 'NotClearedMissions'">Total Not Cleared
                                    Missions :
                                </h4>
                                <h4 ngClass="selectlist-label" *ngIf="usageAnalyticsSelectedValue === 'VoiceCommands'">
                                    Total Voice Commands :
                                </h4>
                                <h4 ngClass="selectlist-label" *ngIf="usageAnalyticsSelectedValue === 'TextCommands'">
                                    Total Text Commands :
                                </h4>
                                <h4 ngClass="selectlist-label" *ngIf="usageAnalyticsSelectedValue === 'separationViolation'">
                                    Total Separation Violations :
                                </h4>
                                <mat-form-field class="mrgn drpdown-chart-options duration-dropdown form-field"
                                    appearance="outline">
                                    <mat-select [(ngModel)]="usageAnalyticsSelectedValue" name="usageEramAnalytics"
                                        (selectionChange)="changeAnalytics($event.value)">
                                        <mat-option class="drp-options" *ngFor="let ua of usageEramAnalytics"
                                            [value]="ua.value">
                                            {{ua.viewValue}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                        <div fxLayout="column">
                            <i class="fa fa-share-square-o" aria-hidden="true"
                                style="font-size: 24px;margin-top:10px; color: #707070; cursor: pointer;"
                                (click)="exportCsvData('usage')"></i>
                        </div>
                    </div>
                </nav>
            </article>
        </mat-card-header>
        <mat-card-content class="flx_tm">
            <!-- <mat-spinner *ngIf="!sessionPlayedChartDatasets" diameter="20" ngClass="loader"></mat-spinner> -->
            <app-highcharts [totalLessionsSessions]="totalLessionsSessions" [updateChart]="updateChart">
            </app-highcharts>
        </mat-card-content>
    </mat-card>
</div>
  <!-- ***************SG-4637 end  ******************* -->
